import React from 'react';
import { List, NumberInput, DateInput, Datagrid, TextField, SimpleForm, TextInput, Create, Toolbar, Edit, SaveButton, EditButton, Filter, 
    NullableBooleanInput, BooleanField, DateField, usePermissions } from 'react-admin';
import MagmoiActions from './magmoiActions';
import EnableDisableButton from './EnableDisableButton';
export const MagmoiList = () => {
    const { permissions } = usePermissions();
return (
    <List empty={false} filters={<MagmoiFilter />} actions={<MagmoiActions />}   >
        <Datagrid bulkActionButtons={false}>
            <TextField source="cod_terr_sap" label="Codice SAP Magazzino" />
            <TextField source="codice_impresa_desc" />
            <TextField source="codice_impresa_sap" />
            <BooleanField source="flag_disattivazione" />
            <DateField source="disattivato_il" locales="it-IT"/>
            <TextField source="disattivato_da" label="Bloccato/ Sbloccato da"/>
            <EnableDisableButton />
            {permissions === 'administrator' && <EditButton /> }
        </Datagrid>
    </List>
)};

export const MagmoiCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="cod_terr_sap" />
            <TextInput multiline source="codice_impresa_desc" />
            <TextInput source="codice_impresa_sap" />
            <TextInput multiline source="desc_indirizzo" />
            <NumberInput source="val_cap" />
            <TextInput source="desc_localita" />
            <TextInput source="desc_prov" />
            <TextInput source="nome_naz" />
            <TextInput source="num_telefono" />
            <TextInput source="num_fax" />
            <TextInput source="e_mail" />
            <TextInput source="flag_valid" />
            <TextInput multiline source="desc_note" />
            <DateInput source="data_agg_sistema" />
            <NumberInput source="flag_tipo_terr_sap" />
            <TextInput source="classe_di_trasporto" />
        </SimpleForm>
    </Create>
);

const MagmoiTitle = ({ record }) => {
    return <span>Magazzino {record ? `${record.codice_impresa_desc}` : ''}</span>;
};

export const MagmoiEdit = ({ permissions, ...props }) => (
    <Edit title={<MagmoiTitle />} {...props}>
        <SimpleForm toolbar={<MagmoiEditToolbar />}>
        <TextInput source="cod_terr_sap" disabled={ (permissions === 'administrator' || permissions === 'tecnico') ? false : true }/>
        <TextInput multiline source="codice_impresa_desc" disabled={ (permissions === 'administrator' || permissions === 'tecnico') ? false : true }/>
        <TextInput source="codice_impresa_sap" disabled={ permissions === 'administrator' ? false : true }/>
        <TextInput multiline source="desc_indirizzo" disabled={ permissions === 'administrator' ? false : true }/>
        <NumberInput source="val_cap" disabled={ permissions === 'administrator' ? false : true }/>
        <TextInput source="desc_localita" disabled={ permissions === 'administrator' ? false : true }/>
        <TextInput source="desc_prov" disabled={ permissions === 'administrator' ? false : true }/>
        <TextInput source="nome_naz" disabled={ permissions === 'administrator' ? false : true }/>
        <TextInput source="num_telefono" disabled={ permissions === 'administrator' ? false : true }/>
        <TextInput source="num_fax" disabled={ permissions === 'administrator' ? false : true }/>
        <TextInput source="e_mail" disabled={ permissions === 'administrator' ? false : true }/>
        <TextInput source="flag_valid" disabled={ permissions === 'administrator' ? false : true }/>
        <TextInput multiline source="desc_note" disabled={ permissions === 'administrator' ? false : true }/>
        <DateInput source="data_agg_sistema" disabled={ permissions === 'administrator' ? false : true }/>
        <NumberInput source="flag_tipo_terr_sap" disabled={ permissions === 'administrator' ? false : true }/>
        <TextInput source="classe_di_trasporto" disabled={ permissions === 'administrator' ? false : true }/>
        </SimpleForm>
    </Edit>
);

const MagmoiEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);


const MagmoiFilter = ({ permissions, ...props }) => (
    <Filter {...props} >
        <TextInput source="cod_terr_sap" />
        <TextInput source="codice_impresa_desc" />
        <NumberInput source="codice_impresa_sap" />
        <NullableBooleanInput source="flag_disattivazione" />
        <DateInput source="disattivato_il_gte" />
        <DateInput source="disattivato_il_lte" />
    </Filter>
);